export default __webpack_public_path__ + "static/media/load.9e467534.gif";